import EventHero from '../components/event/EventHero'

/** The open homepage: the hero alone. Everything else sits behind event access. */
export default function HomePage() {
  return <EventHero />
}
